(function () {
  function initLoadMore(scope = document) {
    const btn = scope.querySelector('[data-loadmore-btn]');
    const list = scope.querySelector('[data-loadmore-list]');
    if (!btn || !list) return;

    if (btn.dataset.bound === '1') return; // 二重バインド防止
    btn.dataset.bound = '1';

    btn.addEventListener('click', async () => {
      const nextUrl = btn.getAttribute('data-next-url');
      if (!nextUrl) return;

      btn.disabled = true;

      try {
        const res = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        const html = await res.text();

        const doc = new DOMParser().parseFromString(html, 'text/html');

        // 次ページ側のリストとボタンを探す
        const nextList = doc.querySelector('[data-loadmore-list]');
        const nextBtn = doc.querySelector('[data-loadmore-btn]');

        if (!nextList) {
          // 取れない = 構造違い or 終端
          btn.style.display = 'none';
          return;
        }

        // 商品カード（.grid__item）だけを移植して追記
        // const newItems = Array.from(nextList.children);
        // newItems.forEach((el) => list.appendChild(el));

        // 商品カード（.grid__item）だけを移植して追記
        const newItems = Array.from(nextList.children);

        newItems.forEach((el) => {
          el.classList.add('is-new');   // ① 最初は透明状態
          list.appendChild(el);
        });

        // ② 次フレームで表示クラスを付与（フェード開始）
        requestAnimationFrame(() => {
          newItems.forEach((el) => el.classList.add('is-in'));
        });



        // 次のURLに更新（なければ終了）
        const newNextUrl = nextBtn ? nextBtn.getAttribute('data-next-url') : '';
        if (newNextUrl) {
          btn.setAttribute('data-next-url', newNextUrl);
          btn.disabled = false;
        } else {
          btn.style.display = 'none';
        }

        // 追加後の簡易再計算（AOS等がある場合の最低限）
        if (window.AOS && typeof window.AOS.refreshHard === 'function') {
          window.AOS.refreshHard();
        } else if (window.AOS && typeof window.AOS.refresh === 'function') {
          window.AOS.refresh();
        }
      } catch (e) {
        console.error('Load more failed:', e);
        btn.disabled = false;
      }
    });
  }

  // 初回
  document.addEventListener('DOMContentLoaded', () => initLoadMore());

  // Impulseはフィルター/ソートで #CollectionAjaxContent が差し替わるので、差し替え後も拾う
  const root = document.querySelector('#CollectionAjaxContent');
  if (root) {
    const obs = new MutationObserver(() => initLoadMore(document));
    obs.observe(root, { childList: true, subtree: true });
  }
})();
